import { UI_CONFIG, type OpenMode } from "../config/ui";

export type UiSettings = {
  openMode: OpenMode;
  readerMaxViewportRatio: number;
};

function clamp(n: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, n));
}

export function getInitialUiSettings(): UiSettings {
  const rawMode = localStorage.getItem(UI_CONFIG.storageKeys.openMode);
  const openMode: OpenMode =
    rawMode === "in-list" || rawMode === "page" || rawMode === "window"
      ? rawMode
      : UI_CONFIG.defaultOpenMode;

  const rawRatio = localStorage.getItem(UI_CONFIG.storageKeys.readerMaxViewportRatio);
  const parsed = rawRatio ? Number(rawRatio) : NaN;

  const readerMaxViewportRatio = Number.isFinite(parsed)
    ? clamp(parsed, 0.2, 0.95)
    : UI_CONFIG.readerMaxViewportRatio;

  return { openMode, readerMaxViewportRatio };
}

export function setOpenMode(openMode: OpenMode) {
  localStorage.setItem(UI_CONFIG.storageKeys.openMode, openMode);
}

export function setReaderMaxViewportRatio(ratio: number) {
  const r = clamp(ratio, 0.2, 0.95);
  localStorage.setItem(UI_CONFIG.storageKeys.readerMaxViewportRatio, String(r));
}

export function applyReaderMaxHeight(ratio: number) {
  const r = clamp(ratio, 0.2, 0.95);
  document.documentElement.style.setProperty("--reader-max-height", `${Math.round(r * 100)}vh`);
}
